import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import moment from 'moment';
import R from 'ramda';
import { RadioButton, RaisedButton, FontIcon } from 'material-ui';
import ReactSelect from 'react-select';

import LoadingOverlay from '../../../tc-ui/loading-overlay';
import { getLocations, getTemplates, updateProps as updatePropsAction } from '../../../../stores/contracting/supplier-wizard/actions';
import { resetRateOptions } from '../../../partner-details/__store__/actions';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const getTemplatesForGroup = (templates, group) => templates.filter(R.compose(R.contains(group._id), R.propOr([], 'templateGroups')));
const getGenitiveCase = (string) => {
  if (!string) return string;
  if (string.slice(-1) === 's') return `${string}'`;
  return `${string}'s`;
};

class SelectTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {
    const { loadedLocations, loadedTemplates, getLocations: getL, getTemplates: getT } = this.props;
    if (!loadedLocations) getL();
    if (!loadedTemplates) getT();
  }
  render() {
    const {
      className,
      companyName,
      dontScroll,
      loadingLocations,
      locationId,
      locations,
      preSetInfo,
      pushAction: push,
      sendTemplateOrGroup,
      templateGroups,
      templateGroupSelected,
      templates,
      templateSelected,
      updatePropsAction: updatePropsFn,
//      isSingleLoc,
    } = this.props;
    const filteredTemplateGroups = templateGroups.filter(group => {
      const tplts = getTemplatesForGroup(templates, group);
      return tplts.every(tplt => R.contains('write', tplt.access || []));
    });
    const groupsForDates = !preSetInfo ? filteredTemplateGroups : (filteredTemplateGroups || []).filter(R.anyPass([
      obj => obj.startDate <= preSetInfo.endDate && obj.startDate >= preSetInfo.startDate,
      obj => obj.endDate <= preSetInfo.endDate && obj.endDate >= preSetInfo.startDate,
      obj => obj.startDate < preSetInfo.startDate && obj.endDate > preSetInfo.endDate,
    ]));
    const templatesForDates = !preSetInfo ? templates : (templates || []).filter(R.anyPass([
      obj => obj.startDate <= preSetInfo.endDate && obj.startDate >= preSetInfo.startDate,
      obj => obj.endDate <= preSetInfo.endDate && obj.endDate >= preSetInfo.startDate,
      obj => obj.startDate < preSetInfo.startDate && obj.endDate > preSetInfo.endDate,
    ]));
    return (
      <div className={className}>
        <LoadingOverlay loading={loadingLocations}/>
        {
          isNilOrEmpty(templatesForDates) ? (
            <div style={{ maxWidth: '700px', height: '380px', display: 'block', marginTop: '48px', textAlign: 'center' }}>
              {`You currently don't have templates ${preSetInfo ? ' for this contracting period' : ''}.`}
              <br/>
              <br/>
              Would you like to load your rates to a template?
              <RaisedButton
                id="openCreateDraftWizard"
                label="create"
                secondary
                style={{ marginLeft: '12px' }}
                onTouchTap={() => push({
                  pathname: `/contracting/create-template-draft`,
                  query: preSetInfo ? {
                    startDate: preSetInfo.startDate,
                    endDate: preSetInfo.endDate,
                    buyerName: preSetInfo.buyerName,
                  } : {},
                })}
              />
            </div>
          ) : <div/>
        }
        {
          !R.propOr(0, 'length', templateGroups) || isNilOrEmpty(templatesForDates) ? <div/> : (
          <div style={{ marginBottom: '32px' }}>
            Would you like to send an individual template or a template group?
            <div style={{ marginTop: '1em' }}>
            <RadioButton
              label="template"
              checked={sendTemplateOrGroup === 'template'}
              onCheck={() => {
                updatePropsFn({ sendTemplateOrGroup: 'template' });
                this.props.resetRateOptions();
              }}
            />
            <RadioButton
              label="template group"
              checked={sendTemplateOrGroup === 'group'}
              onCheck={() => {
                updatePropsFn({ sendTemplateOrGroup: 'group' });
                this.props.resetRateOptions();
              }}
            />
            </div>
          </div>)
        }
        {
          (sendTemplateOrGroup === 'template' || !R.propOr(0, 'length', templateGroups)) && !isNilOrEmpty(templatesForDates) && (
            <div style={{
              maxWidth: '700px',
              margin: 'auto',
              ...(dontScroll ? {} : { height: '380px', display: 'block', overflowY: 'scroll' }) }}
            >
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                Select the template that you would like to send.
              </div>
              <div style={{ margin: '0 24px', display: locations.length > 1 ? 'block' : 'none' }}>
                <ReactSelect
                  style={{ fontSize: '14px' }}
                  name="allocation"
                  options={locations.filter(R.compose(R.contains('write'), R.prop('access'))).map(loc => ({ value: loc.id, label: loc.name }))}
                  value={locationId}
                  onChange={({ value }) => updatePropsFn({ locationId: value })}
                  placeholder="Please select a location"
                  clearable={false}
                  scrollMenuIntoView={false}
                />
              </div>
              {
                locationId ? (
                  <div style={{ paddingLeft: '40px' }}>
                    Depracated Small Template List
                  </div>) : <div/>
              }
            </div>
          )
        }
        {
          sendTemplateOrGroup === 'group' && groupsForDates.length ? (
            <div style={{
              maxWidth: '700px',
              margin: 'auto',
              ...(dontScroll ? {} : { height: '380px', display: 'block', overflowY: 'scroll' }) }}
            >
              <div style={{ textAlign: 'center' }}>
                Select the template group that you would like to send.
              </div>
              <div style={{ margin: '24px' }}>
                <ReactSelect
                  style={{ fontSize: '14px' }}
                  name="group"
                  options={groupsForDates.map(group => ({ value: group._id, group, label: group.groupName }))}
                  value={R.propOr('', '_id', templateGroupSelected)}
                  onChange={({ group }) => updatePropsFn({
                    templateGroupSelected: R.merge(group, { templates: getTemplatesForGroup(templates, group) }),
                    message: `Please find ${getGenitiveCase(companyName)} ${moment(group.startDate).utc().startOf('day').format('DD MMM YYYY')} - ${moment(group.endDate).utc().startOf('day').format('DD MMM YYYY')} rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.`,
                    subject: `${companyName} ${moment(group.startDate).utc().get('year')}-${moment(group.endDate).utc().get('year')} Rates`,
                  })}
                  placeholder="Please select a template group"
                  clearable={false}
                  scrollMenuIntoView={false}
                />
              </div>
              {!isNilOrEmpty(templateGroupSelected) && getTemplatesForGroup(templates, templateGroupSelected)
              .map(({ templateName, locationName }, i) => (
                <div key={`${i}${templateName}`} style={{ color: 'rgba(0, 0, 0, 0.54)', marginLeft: '48px' }}>
                  <div style={{ height: '40px', display: 'flex', alignItems: 'center' }}>
                    <FontIcon className="tc-icon-description" color="rgba(0, 0, 0, 0.54)" />
                  <div>
                    {locationName}<small style={{ paddingLeft: '2px' }}>({templateName})</small>
                  </div>
                </div>
              </div>))}
            </div>
          ) : <div/>
        }
        {
          sendTemplateOrGroup === 'group' && isNilOrEmpty(groupsForDates) ? (
            <div style={{ maxWidth: '700px', height: '380px', display: 'block', marginTop: '48px', textAlign: 'center' }}>
              {`You currently don't have template groups${!preSetInfo ? ' for this contracting period' : ''}.`}
              <br/>
              <br/>
              Would you like to create a template group?
              <RaisedButton
                label="create"
                secondary
                style={{ marginLeft: '12px' }}
                onTouchTap={() => push('/contracting/create-template-group')}
              />
            </div>
          ) : <div/>
        }
      </div>
    );
  }
}

SelectTemplate.propTypes = {
  className: PropTypes.string,
  companyName: PropTypes.string,
  dontScroll: PropTypes.bool.isRequired,
  getLocations: PropTypes.func,
  getTemplates: PropTypes.func,
  loadedLocations: PropTypes.bool,
  loadedTemplates: PropTypes.bool,
  loadingLocations: PropTypes.bool,
  locationId: PropTypes.string, // sent from aboce
  locations: PropTypes.array,
  preSetInfo: PropTypes.object, // sent from above
  pushAction: PropTypes.func,
  resetRateOptions: PropTypes.func,
  sendTemplateOrGroup: PropTypes.string,
  templateGroups: PropTypes.array,
  templateGroupSelected: PropTypes.object,
  templates: PropTypes.array,
  templateSelected: PropTypes.object,
  updatePropsAction: PropTypes.func,
};

SelectTemplate.defaultProps = {
  className: '',
  dontScroll: false,
};

const mapStateToProps = ({ user, contracting: { supplierWizard } }) => ({
  companyName: user.getIn(['company', 'companyName']),
  loadedLocations: supplierWizard.get('loadedLocations'),
  loadedTemplates: supplierWizard.get('loadedTemplates'),
  loadingLocations: supplierWizard.get('loadingLocations'),
  locationId: supplierWizard.get('locationId'),
  locations: supplierWizard.get('locations').toJS(),
  sendTemplateOrGroup: supplierWizard.get('sendTemplateOrGroup'),
  templateGroups: supplierWizard.get('templateGroups').toJS(),
  templateGroupSelected: supplierWizard.get('templateGroupSelected').toJS(),
  templates: supplierWizard.get('templates').toJS(),
  templateSelected: supplierWizard.get('templateSelected').toJS(),
//  ...contracting.supplierWizard.toJS(),
//  isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
//  preSetInfo: supplierWizard.get('preSetInfo').toJS(),
});

export default connect(mapStateToProps, {
  getLocations,
  getTemplates,
  pushAction,
  resetRateOptions,
  updatePropsAction,
})(SelectTemplate);



// WEBPACK FOOTER //
// ./src/app/components/contracting/supplier-wizard/supplier-initiated/select-template.jsx